<template>
  <!--举报-->
  <div
    aria-labelledby="myModalLabel"
    class="modal fade"
    id="complaint2"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="iconfont icon-close"></i>
          </button>
          <h4 class="modal-title" id="myModalLabel">被举报人：{{share_creater_name}}</h4>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <textarea
              class="form-control"
              placeholder="举报内容"
              rows="5"
              style="resize: vertical;"
              maxlength="200"
              autofocus
              v-model="form.message"
              name="message"
              data-vv-as="举报内容 "
              v-validate="{ required:true, min:1,max:100 }"
            ></textarea>
            <span class="help-block" v-show="errors.has('message')">{{ errors.first('message') }}</span>
          </div>
          <div class="form-group">
            <select
              class="form-control"
              v-model="form.type"
              name="type"
              data-vv-as="举报类型 "
              v-validate="'included:1,2,3,4,0'"
            >
              <option v-for="type in types" :key="type.id" :value="type.id">{{type.content}}</option>
            </select>
            <span class="help-block" v-show="errors.has('type')">{{ errors.first('type') }}</span>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" data-dismiss="modal" type="button">关闭</button>
          <button class="btn btn-primary" type="button" @click="createShareReport">提交</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createShareReport } from "@/api/share/share";
export default {
  name: "TableComplaintSelected",
  data() {
    return {
      form: {
        type: 1,
        message: null,
        numbers: []
      },
      types: [
        {
          id: 1,
          content: "传播危害国家安全、以及侮辱、诽谤、淫秽、暴力的内容"
        },
        { id: 2, content: "传播侵害他人名誉、知识产权等内容" },
        { id: 3, content: "虚构事实、误导、欺骗他人" },
        { id: 4, content: "发表、传播广告信息及垃圾信息" },
        { id: 0, content: "其他" }
      ]
    };
  },
  computed: {
    selectedDatas() {
      return this.$store.state.drive.selectedDatas;
    },
    share_creater_name() {
      return this.$store.state.drive.share.share_creater_name;
    }
  },
  methods: {
    setDetail() {
      this.form.numbers = this.selectedDatas.map(function(item) {
        return item.number;
      });
    },
    createShareReport() {
      this.$validator.validate().then(valid => {
        if (valid) {
          let params = {
            share_number: this.$store.state.drive.share.share_number,
            share_resources_list: this.form.numbers,
            report_content: this.form.message,
            report_type: this.form.type
          };
          createShareReport(params)
            .then(res => {
              if (res.status_code === 200) {
                $("#complaint2").modal("hide");
                this.$message({
                  type: "success",
                  message: res.message
                });
                this.form.message = "";
                this.$nextTick(() => {
                  this.$validator.reset();
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message
                });
              }
            })
            .catch(err => {
              this.$message({
                type: "error",
                message: err
              });
            });
        }
      });
    }
  },
  mounted() {
    let that = this;
    $("#complaint2").on("show.bs.modal", function(e) {
      that.$nextTick(() => {
        that.setDetail();
      });
    });
  },
  destroyed() {
    $("#complaint2").off();
  }
};
</script>

<style scoped>
</style>